import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api, formatErr } from "../lib/api";
import { useAuth } from "../lib/auth";
import Navbar from "../components/Navbar";
import { Check, Sparkles } from "lucide-react";
import { toast } from "sonner";

export default function Pricing() {
  const { user } = useAuth();
  const nav = useNavigate();
  const [pkgs, setPkgs] = useState([]);
  const [loadingId, setLoadingId] = useState(null);

  useEffect(() => {
    api.get("/pricing").then(r => setPkgs(r.data.packages));
  }, []);

  const buy = async (pkgId) => {
    if (!user) { nav("/registrati"); return; }
    setLoadingId(pkgId);
    try {
      let r;
      if (pkgId === "check_singolo") {
        // One-time payment (invariato)
        r = await api.post("/checkout/session", {
          package_id: pkgId,
          origin_url: window.location.origin,
        });
      } else {
        // Recurring subscription (base | plus)
        r = await api.post("/subscriptions/checkout", {
          plan: pkgId,
          origin_url: window.location.origin,
        });
      }
      window.location.href = r.data.url;
    } catch (ex) {
      toast.error(formatErr(ex.response?.data?.detail));
      setLoadingId(null);
    }
  };

  return (
    <div className="min-h-screen bg-[#F9F8F6]">
      <Navbar />
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="text-center">
          <div className="label-caps">Piani IVA Radar</div>
          <h1 className="font-serif-display text-4xl lg:text-5xl text-[#1E3F33] mt-3">Scegli come tenere sotto controllo la tua IVA</h1>
          <p className="mt-4 text-[#6B6B6B] max-w-2xl mx-auto">Un check singolo, un piano mensile, o la versione completa con proiezioni e export PDF. Tutti i prezzi sono al netto di IVA.</p>
        </div>

        <div className="mt-12 grid grid-cols-1 lg:grid-cols-3 gap-6">
          {pkgs.map((p) => {
            const active = user?.plan === p.id;
            const highlighted = p.highlighted;
            return (
              <div key={p.id} data-testid={`pricing-card-${p.id}`}
                className={`card-flat p-8 flex flex-col ${highlighted ? "border-[#1E3F33] ring-1 ring-[#1E3F33]" : ""}`}>
                {highlighted && (
                  <div className="flex items-center gap-1 text-xs text-[#C25934] mb-3">
                    <Sparkles size={12}/> Consigliato
                  </div>
                )}
                <h3 className="font-serif-display text-3xl text-[#1E3F33]">{p.name}</h3>
                <div className="mt-3 flex items-baseline gap-2">
                  <div className="font-serif-display text-5xl text-[#1E3F33]">€{p.price}</div>
                  <div className="text-sm text-[#6B6B6B]">{p.period}</div>
                </div>
                {p.type === "subscription" && (
                  <div className="mt-1 text-xs text-[#6B6B6B]">Rinnovo automatico · Annulli quando vuoi</div>
                )}
                <ul className="mt-6 space-y-3 flex-grow">
                  {p.features.map((f, i) => (
                    <li key={i} className="flex items-start gap-2 text-sm text-[#2C2C2C]">
                      <Check size={16} className="text-[#1E3F33] mt-0.5 shrink-0"/>
                      <span>{f}</span>
                    </li>
                  ))}
                </ul>
                <button data-testid={`pricing-buy-${p.id}`} onClick={()=>buy(p.id)} disabled={loadingId===p.id || active}
                  className={`btn-lift mt-8 w-full py-3 rounded-md ${active ? "bg-[#EBE5DF] text-[#6B6B6B] cursor-default" : highlighted ? "bg-[#1E3F33] text-white hover:bg-[#152D24]" : "border border-[#1E3F33] text-[#1E3F33] hover:bg-[#EBE5DF]"}`}>
                  {active ? "Piano attivo" : loadingId===p.id ? "Reindirizzamento…" : "Sottoscrivi"}
                </button>
              </div>
            );
          })}
        </div>

        <p className="mt-12 text-xs text-[#6B6B6B] text-center max-w-2xl mx-auto italic">
          Piano Base e Plus si rinnovano automaticamente ogni mese. Puoi annullare in qualsiasi momento dalle Impostazioni (manterrai l'accesso fino a fine periodo). Pagamenti sicuri gestiti da Stripe. IVA Radar è uno strumento di stima a supporto della pianificazione di liquidità e non sostituisce il commercialista.
        </p>
      </div>
    </div>
  );
}
